import routesHelper from "../router/routeshelper";

export const  isAuthenticated = () => {

    if(routesHelper.getAuthToken()) {
        return true
    }
    return false;
}